const MAX_SELECTED_ROWS = 20;

function preProcessRequestData(data) {
  const {
    id: _id,
    serviceProviderId: _serviceProviderId,
    recordVersion: _recordVersion,
    createdDateTime: _createdDateTime,
    lastModifiedDateTime: _lastModifiedDateTime,
    insightPurchased: _insightPurchased,
    ...other
  } = data;

  return {
    ...other,
    isVoiceEnabled: other.isVoiceEnabled === true,
    isVoiceDefault: other.isVoiceDefault === true,
    isTextEnabled: other.isTextEnabled === true,
    isTextDefault: other.isTextDefault === true,
    smsSubscriptionStatus: data.smsSubscriptionStatus,
  };
}

function preProcessSubmitData(data) {
  const {
    id: _id,
    serviceProviderId: _serviceProviderId,
    smsSubscriptionStatus: _smsSubscriptionStatus,
    recordVersion: _recordVersion,
    createdDateTime: _createdDateTime,
    lastModifiedDateTime: _lastModifiedDateTime,
    insightPurchased: _insightPurchased,
    ...other
  } = data;

  return {
    ...other,
    isVoiceEnabled: other.isVoiceEnabled === true,
    isVoiceDefault: other.isVoiceDefault === true,
    isTextEnabled: other.isTextEnabled === true,
    isTextDefault: other.isTextDefault === true,
  };
}

function getDefaultValues(insightPurchased) {
  return {
    phoneNumber: '',
    description: '',
    isVoiceEnabled: false,
    isVoiceDefault: false,
    isTextEnabled: false,
    isTextDefault: false,
    smsSubscriptionStatus: null,
    insightPurchased,
  };
}

function toDeleteRowPreview(row) {
  return {
    id: row?.id,
    phoneNumber: row?.phoneNumber,
    description: row?.description,
  };
}

function applyRowSelection({ selectedRows, rowsToAdd, updater }) {
  const pageRowIds = new Set(rowsToAdd.map(row => row.id));
  const previousSelection = Object.fromEntries(
    selectedRows.map(row => [row.id, true]),
  );

  const nextSelection =
    typeof updater === 'function'
      ? updater(previousSelection)
      : { ...previousSelection, ...updater };

  const offPageRows = selectedRows.filter(row => !pageRowIds.has(row.id));
  const onPageRows = rowsToAdd
    .filter(row => nextSelection[row.id])
    .map(toDeleteRowPreview);

  const nextRows = [...offPageRows, ...onPageRows];

  if (nextRows.length <= MAX_SELECTED_ROWS) {
    return { selectedRows: nextRows, limitReached: false };
  }

  const hadAnyPageSelected = rowsToAdd.some(row => previousSelection[row.id]);
  const isSelectAllPage =
    rowsToAdd.length > 0 && rowsToAdd.every(row => nextSelection[row.id]);

  if (selectedRows.length >= MAX_SELECTED_ROWS) {
    if (hadAnyPageSelected) {
      return { selectedRows: offPageRows, limitReached: false };
    }

    if (isSelectAllPage) {
      return { selectedRows: [], limitReached: false };
    }

    return { selectedRows, limitReached: true, rejected: true };
  }

  return {
    selectedRows: nextRows.slice(0, MAX_SELECTED_ROWS),
    limitReached: true,
  };
}

export {
  MAX_SELECTED_ROWS,
  preProcessRequestData,
  preProcessSubmitData,
  getDefaultValues,
  toDeleteRowPreview,
  applyRowSelection,
};
